import BigNumber from "bignumber.js";

export function toBigItem(num, bit = 18) {
  return new BigNumber(`${num}e+${bit}`);
}
export function toBigNum(num, bit = 18) {
  const fmt = {
    prefix: "",
    decimalSeparator: ".",
    groupSeparator: "",
    groupSize: 3,
    secondaryGroupSize: 0,
    fractionGroupSeparator: " ",
    fractionGroupSize: 0,
    suffix: ""
  };
  return new BigNumber(`${num}e+${bit}`).toFormat(fmt);
}
export function toSmallNum(num, bit = 18) {
  const num_big = new BigNumber(num);
  return num_big.div(`1e+${bit}`).toNumber();
}
export function toSmallNumStr(num, bit = 18) {
  const fmt = {
    prefix: "",
    decimalSeparator: ".",
    groupSeparator: ",",
    groupSize: 3,
    secondaryGroupSize: 0,
    fractionGroupSeparator: " ",
    fractionGroupSize: 0,
    suffix: ""
  };
  const num_big = new BigNumber(num);
  return num_big.div(`1e+${bit}`).toFormat(fmt);
}
export function toSmallNumStr2(num, bit = 18) {
  const fmt = {
    prefix: "",
    decimalSeparator: ".",
    groupSeparator: ",",
    groupSize: 0,
    secondaryGroupSize: 0,
    fractionGroupSeparator: " ",
    fractionGroupSize: 0,
    suffix: ""
  };
  const num_big = new BigNumber(num);
  return num_big.div(`1e+${bit}`).toFormat(fmt);
}
export function fixed(num, count = 4) {
  let num_str = String(num);
  let num_arr = num_str.split(".");
  let res = "";
  res = num_arr[0] + (num_arr[1] ? "." + num_arr[1].substring(0, count) : "");
  return res;
}
